import hashSum from 'hash-sum'
import { nanoid } from 'nanoid'

export function checkEmail(v: string) {
  return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(v)
}

export function hash(data: Object | string): string {
  return hashSum(data)
}

export function generateId(): string {
  return nanoid()
}

export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}